export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_fragment_4.0f007f14.jpg";